import React from 'react';
import {Row, Col, Label } from "reactstrap";

export default class CheckboxDetalhado extends React.Component {
    constructor(props) {
        super(props);
    }

    handleClick = () => this.props.onClick(this.props.index)

    render() {
    	return (
            <div className="checkbox-detalhado" onClick={ this.handleClick }>
                <div className='card-branco'
                onMouseOver={this.props.renderizarTextoNota? this.props.renderizarTextoNota : ''}
                onMouseLeave={this.props.tirarTextoDaTelaNota? this.props.tirarTextoDaTelaNota : ''}>
                    <label className="control control-checkbox float-right">
                        <span><input type="checkbox" onChange={ this.handleChange } checked={ this.props.checked }/>
                        <div className="control_indicator" onClick={ this.handleClick }></div></span>
                        <div className="clearboth"></div>
                    </label>
                    <h2>{ this.props.titulo }</h2>
                    <Label className="label-disabled">{ this.props.descricao }</Label>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/CheckboxDetalhado.js